import React, { useRef } from "react";
import { Table } from "reactstrap";
import numberToWords from "../../../../Components/Common/numberToWords";

const ReceiptPrint = ({
  selectedCustomer,
  selectedPayment,
  rawOrder,
  promoSuccess,
  discountAmount,
  orgInfo,
  user,
  selectedTable,
  orderId,
  items,
  calculateTotals,
}) => {
  console.log("🚀 ~ ReceiptPrint ~ items:", items);
  const billRef = useRef();

  const expandItemsForPrint = (items) => {
    const finalList = [];
    console.log("🚀 ~ expandItemsForPrint ~ finalList:", finalList);

    items.forEach((item) => {
      // Push normal quantity (if > 0)
      if (item.quantity > 0) {
        finalList.push({
          itemName: item.productName,
          quantity: item.quantity,
          unitPrice: item.productPrice,
          totalPrice: item.productPrice * item.quantity,
          complimentaryQuantity: 0,
          isComplimentary: false,
        });
      }

      // Push complimentary quantity (if > 0)
      if (item.complimentaryQuantity > 0) {
        finalList.push({
          itemName: item.productName + " (Complimentary)",
          quantity: item.complimentaryQuantity,
          unitPrice: 0,
          totalPrice: 0,
          complimentaryQuantity: item.complimentaryQuantity,
          isComplimentary: true,
        });
      }
    });

    return finalList;
  };

  const handlePrint = () => {
    console.log("here we are at 4");
    //if its via mobile apk and setting matches trigger kot
    const isFromApp = navigator.userAgent.includes("CloudRestroAPK");
    const isSettingMatched = true;

    const billData = {
      orgInfo,
      user,
      selectedTable,
      orderId: orderId, // from props
      items: items, // from props

      // items: expandItemsForPrint(items),
      calculateTotals: calculateTotals, // from props
      selectedCustomer: selectedCustomer || null,
      selectedPayment: selectedPayment || null,
      promoSuccess: promoSuccess,
      discountAmount: discountAmount || 0,
      rawOrder: rawOrder,
    };
    console.log("🚀 ~ handlePrint ~ billData:", billData);

    if (isFromApp && isSettingMatched) {
      console.log("Running inside APK WebView for printing bill");
      console.log("Hey");

      // const userData = JSON.parse(localStorage.getItem("user") || "{}");
      // const token = userData.accessToken || userData.token || null;

      // Build the bill payload

      const payload = encodeURIComponent(JSON.stringify(billData));
      console.log("It is bill", billData);
      window.location.href = `app://printBill?data=${payload}`;
    } else {
      console.log("Running in normal browser");
    }

    // // Check if running in React Native WebView
    // if (window.ReactNativeWebView) {
    //   // Prepare bill data for printing
    //   const billData = {
    //     orgInfo,
    //     user,
    //     selectedTable,
    //     orderId,
    //     items,
    //     calculateTotals,
    //     selectedCustomer,
    //     selectedPayment,
    //     promoSuccess,
    //     discountAmount,
    //     rawOrder,
    //   };
    //   // Send data to React Native
    //   window.ReactNativeWebView.postMessage(JSON.stringify({
    //     type: 'PRINT_BILL',
    //     data: billData,
    //   }));
    // } else {
    //   // Fallback to browser print
    //   window.print();
    // }
  };

  // const handlePrint = () => {
  //   console.log("here we are at 4");
  //   const isFromApp = navigator.userAgent.includes("CloudRestroAPK");
  //   const isSettingMatched = true;

  //   // if (isFromApp && isSettingMatched) {
  //     console.log("Running inside APK WebView for printing bill");

  //     // 🧾 Get user token
  //     const userData = JSON.parse(localStorage.getItem("user") || "{}");
  //     const token = userData.accessToken || userData.token || null;

  //     // 🧾 Build bill object (keep your logic same)
  //     const bill = {
  //       orgInfo,
  //       user,
  //       selectedTable,
  //       orderId,
  //       items,
  //       calculateTotals,
  //       selectedCustomer: selectedCustomer || null,
  //       selectedPayment: selectedPayment || null,
  //       promoSuccess,
  //       discountAmount: discountAmount || 0,
  //       rawOrder,
  //     };

  //     // ✅ Wrap token + bill just like required
  //     const finalPayload = {
  //       token: token,
  //       bill: bill,
  //     };
  //     console.log("user flatten check:", user?.user?.email, user?.email, user?.userName);

  //     console.log("🚀 ~ handlePrint ~ finalPayload:", finalPayload)

  //     // Encode and send
  //     const payload = encodeURIComponent(JSON.stringify(finalPayload));
  //     console.log("🧾 Final Payload to send:", finalPayload);

  //     // Trigger print via app deep link
  //     window.location.href = `app://printBill?data=${payload}`;
  //   // } else {
  //   //   console.log("Running in normal browser");
  //   // }

  //   // (Keep your commented React Native WebView code untouched)
  // };

  return (
    <>
      <button
        className="btn btn btn-soft-success shadow-sm  align-items-center d-flex align-content-center justify-content-center gap-3"
        onClick={handlePrint}
      >
        <i className="ri-printer-line"></i>
        Print Bill
      </button>

      <div ref={billRef} className="print-area">
        <div
          className="d-flex flex-column p-3"
          style={{ fontFamily: "monospace", fontSize: "14px" }}
        >
          {/* Header */}
          <div className="text-center mb-2">
            <h5 className="fw-bold text-uppercase mb-0">
              {orgInfo?.name || "My Restaurant"}
            </h5>
            <div className="text-uppercase">{orgInfo?.address1 || ""}</div>
            <div>{orgInfo?.tel || "000-0000000"}</div>
            <div className="fw-bold mt-1">INVOICE</div>
          </div>

          {/* Info Rows */}
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>PAN No.:</strong> {orgInfo?.pan || "..."}
            </div>
            <div>
              <strong>Copy of:</strong> Original
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Customer:</strong>{" "}
              {selectedCustomer
                ? `${selectedCustomer.firstName} ${selectedCustomer.lastName}`
                : "...."}
            </div>
            <div>
              <strong>PAN:</strong> {"..."}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Phone No.:</strong> {selectedCustomer?.phoneNo || "...."}
            </div>
            <div>
              <strong>Cashier:</strong> {"..."}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Address:</strong> {selectedCustomer?.address || "...."}
            </div>
            <div>
              <strong>INV No:</strong> {orderId || "..."}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-2">
            <div>
              <strong>Date (A.D.):</strong> {new Date().toLocaleDateString()}
            </div>
            <div>
              <strong>Time:</strong>{" "}
              {new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>

          {/* Table */}
          <Table size="sm" responsive className="table-bordered small mb-0">
            <thead>
              <tr>
                <th>SN</th>
                <th>Item</th>
                <th className="text-center">Qty</th>
                <th className="text-center">Rate</th>
                <th className="text-end">Amnt</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.productName}</td>
                  <td className="text-center">
                    {item?.complimentaryQuantity > 0
                      ? item.complimentaryQuantity
                      : item.quantity}
                  </td>
                  <td className="text-center">
                    {item?.productPrice?.toFixed(2)}
                  </td>
                  <td className="text-end">
                    {(
                      item.productPrice *
                      (item?.complimentaryQuantity || item.quantity)
                    ).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Totals */}
          <div className="border-top pt-2 small">
            <div className="d-flex justify-content-between">
              <div>Total Qty:</div>
              <div>
                {items?.reduce(
                  (total, item) =>
                    total + item?.quantity + (item?.complimentaryQuantity || 0),
                  0
                )}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div
                onClick={() => {
                  console.log(calculateTotals);
                }}
              >
                Sub Total:
              </div>
              <div>Rs. {calculateTotals?.subTotal?.toFixed(2)}</div>
            </div>
            {/* <div className="d-flex justify-content-between">
                  <div>Discount Amount:</div>
                  <div>-Rs {calculateTotals.discount.toFixed(2)}</div>
                </div> */}

            {(promoSuccess || discountAmount) && (
              <div className="d-flex justify-content-between">
                <div>Discount Amount:</div>
                <div>Rs {calculateTotals.discount.toFixed(2)}</div>
              </div>
            )}
            <div className="d-flex justify-content-between fw-bold">
              <div>Net Amount:</div>
              <div>Rs. {calculateTotals.total.toFixed(2)}</div>
            </div>
            <div className="mt-2">
              <div>
                <strong>In Words:</strong>{" "}
                {numberToWords(calculateTotals.total)}
              </div>
            </div>
            <div className="mt-2">
              <div>
                Payment Mode: {selectedPayment?.name} (Rs{" "}
                {calculateTotals.total.toFixed(2)})
              </div>
            </div>
            <div className="mt-2">
              <div>Billed by: {user?.name || "Staff"}</div>
            </div>
          </div>

          {/* Footer Info */}
          <div className="small mt-2">
            <div className="text-center mt-2">**Thank You**</div>
            <div className="text-center text-muted small">
              Powered by Restro Order
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceiptPrint;
